import { render, staticRenderFns } from "./PaymentPlanSetup.vue?vue&type=template&id=4bdb5e0f&scoped=true"
import script from "./PaymentPlanSetup.vue?vue&type=script&lang=js"
export * from "./PaymentPlanSetup.vue?vue&type=script&lang=js"
import style0 from "./PaymentPlanSetup.vue?vue&type=style&index=0&id=4bdb5e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb5e0f",
  null
  
)

export default component.exports